// no need for axios on mutations so far, fetch for get reqs for app router
const $api = {
  get: async <T,>(url: string, config?: RequestInit) => {
    const response = await fetch(url, {
      method: 'GET',
      ...(config || {})
    })
    if (!response.ok) {
      throw new Error('Ошибка')
    }
    return response.json() as Promise<T>
  },
  post: async <T,>(url: string, data: unknown, config?: RequestInit) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(config?.headers || {})
      },
      body: JSON.stringify(data),
      ...(config || {})
    })
    if (!response.ok) {
      throw new Error('Ошибка')
    }
    return response.json() as Promise<T>
  }
}

export { $api }
